import script from "./MaterialManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialManagement.vue?vue&type=script&setup=true&lang=js"

import "./MaterialManagement.vue?vue&type=style&index=0&id=11b73b84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11b73b84"]])

export default __exports__